// v2/hooks/useAuth.js
import { useCallback, useSyncExternalStore } from 'react';
import {
  abone,
  oturumBilgisi,
  oturumKaydet,
  oturumuSonlandir,
  hatirlananBilgi,
} from '../utils/authStore';
import { apiPost, apiGet } from '../utils/api';

export default function useAuth() {
  const durum = useSyncExternalStore(abone, oturumBilgisi, oturumBilgisi);

  const girisYap = useCallback(async ({ email, password, kvkkChecked = true, rememberMe = false }) => {
    const veri = await apiPost(
      '/login/',
      { email, password, kvkk_checked: kvkkChecked },
      { oturumsuz: true }
    );
    if (!veri || !veri.success || !veri.user || !veri.user.token) {
      return { ok: false, mesaj: (veri && veri.message) || 'Gecersiz email veya sifre' };
    }
    oturumKaydet(veri.user, { rememberMe, email, password });
    return { ok: true, user: veri.user };
  }, []);

  const cikisYap = useCallback(async () => {
    const { token } = oturumBilgisi();
    try {
      if (token) await apiPost('/logout/', { token }, { oturumsuz: true });
    } catch (e) {
      /* sunucu hatasi cikisi engellemesin */
    }
    oturumuSonlandir();
  }, []);

  // validate-token/ ile sunucuya sorar. true/false doner.
  const tokenGecerliMi = useCallback(async () => {
    const { token } = oturumBilgisi();
    if (!token) return false;
    try {
      const veri = await apiGet('/validate-token/', { oturumsuz: true });
      return Boolean(veri && veri.valid);
    } catch (e) {
      return false;
    }
  }, []);

  return {
    user: durum.user,
    token: durum.token,
    kod: durum.user ? durum.user.kod : null,
    adSoyad: durum.user ? durum.user.ad_soyad : null,
    girisli: durum.girisli,
    admin: durum.admin,
    girisYap,
    cikisYap,
    tokenGecerliMi,
    hatirlananBilgi,
  };
}
